var CryptoJS = require("crypto-js");

export function myEncrypt(text, password) {
    return CryptoJS.AES.encrypt(text, password).toString();
};

export function myDecrypt(text, password) {
    var bytes = CryptoJS.AES.decrypt(text, password);
    return bytes.toString(CryptoJS.enc.Utf8);
};